export const baseApiurl = {
  Dev_old: `https://mdqualityapps.in/API/igreen_cms/development/`,
  Dev_new: `https://igreentechnologies.in/cmsapi/igreen_dev/`,
  Prod: `https://igreentechnologies.in/cmsapi/production/`,
};
